export class Client {
    Id: number;
    FName: string;
    LName: string;
    Email: string;
    Address: string;
    Phone: string;
    Updated: string;
    Created: string;
    Active: boolean;
  }